// LoaderOverlay.tsx
import React from "react";
import classes from "./LoadingOverlay.module.css"; // Create this CSS file
import { t } from "i18next";

export const LoaderOverlay: React.FC = () => {
  return (
    <div className={classes.overlay}>
      <div className={classes.spinner}></div>
      <p className={classes.text}>{t("common.loading")}</p>
    </div>
  );
};
